import React, { useState, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Swiper from '@components/Swiper';
import { isNullOrUndefined } from '@utils/object';
import Tab from './components/Tab';
import Container from './components/Container';

const StyledSwiper = styled(Swiper)`
  padding: 0;
  height: 100%;
  & > * {
    margin: 0;
  }
  & > *:first-child {
    margin: 0;
  }
`;

function Tabs({ tabs, onSelect, tabSelectedId, swipeable, className }) {
  const [selectedTab, setSelectedTab] = useState(tabSelectedId);
  const tabsWidth = useMemo(() => (swipeable ? null : 100 / tabs.length), [
    swipeable,
    tabs,
  ]);

  const onClick = useCallback(
    id => {
      setSelectedTab(id);
      onSelect(id);
    },
    [onSelect],
  );

  useEffect(() => {
    if (!isNullOrUndefined(tabSelectedId)) {
      setSelectedTab(tabSelectedId);
    }
  }, [tabSelectedId]);

  return (
    <Container className={className}>
      <StyledSwiper id="tabs" enabled={swipeable}>
        {tabs.map(tab => (
          <Tab
            width={tabsWidth}
            onClick={onClick}
            key={tab.id}
            id={tab.id}
            selected={selectedTab === tab.id}
            text={tab.name}
          />
        ))}
      </StyledSwiper>
    </Container>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  tabSelectedId: PropTypes.number,
  swipeable: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,

  // from styled components
  className: PropTypes.string.isRequired,
};

Tabs.defaultProps = {
  tabSelectedId: 1,
  swipeable: false,
};

export default styled(Tabs)``;
